import {
  CheckNotes,
  InspectionCase,
  InspectionPreactionSystemCase,
  InspectionPreactionSystemCaseDto,
  InspectionTimeCase,
  InspectionTimeCaseDto,
  InspectionWaterSupplyDataCase,
  InspectionWaterSupplyDataCaseDto
} from '../../inspection-cases';
import { WaterFlowPressure } from '../../water-flow-pressure.dto';

export class PreactionSystemsDto extends InspectionCase {
  deploymentAccordingSpec?: InspectionCase;
  pipingDesignType?: InspectionCase;
  preactionSystemType?: InspectionPreactionSystemCaseDto;
  systemTopPipingVolumeAccordingSpec?: InspectionCase;
  maxWaterNeededAtMainStation?: InspectionWaterSupplyDataCaseDto;
  maxWaterNeededAtSource?: InspectionWaterSupplyDataCaseDto;
  sprinklerOffTimeRequirenments?: InspectionTimeCaseDto;
  requiredPoolingVolume?: InspectionWaterSupplyDataCaseDto;
  hydraulicWaterRequirementMatchWaterSupplyDesign?: InspectionCase;
}

export class PreactionSystems extends PreactionSystemsDto {
  constructor(
    data: PreactionSystemsDto = { title: 'מערכות פעולה מקדימה במים' }
  ) {
    super(data);
    this.deploymentAccordingSpec = new InspectionCase({
      ...data.deploymentAccordingSpec,
      title: 'פריסת המתזים / נחירים מתאימה לדרישות התקן?'
    });
    this.pipingDesignType = new InspectionCase({
      ...data.pipingDesignType,
      title: 'סוג הצנרת שתוכנן'
    });
    this.preactionSystemType = new InspectionPreactionSystemCase({
      ...data.preactionSystemType,
      title:
        'ציין את סוג המערכת: single interlock, non interlock, double interlock'
    });
    this.systemTopPipingVolumeAccordingSpec = new InspectionCase({
      ...data.systemTopPipingVolumeAccordingSpec,
      title: 'נפח הצנרת לראש מערכת מתאים לדרישות התקן?'
    });
    this.maxWaterNeededAtMainStation = new InspectionWaterSupplyDataCase({
      ...data.maxWaterNeededAtMainStation,
      title: 'דרישת המים המירבית הדרושה במבוא לתחנת ההפעלה הראשית',
      waterFlowPressure: new WaterFlowPressure(
        data.maxWaterNeededAtMainStation?.waterFlowPressure
      )
    });
    this.maxWaterNeededAtSource = new InspectionWaterSupplyDataCase({
      ...data.maxWaterNeededAtSource,
      title: 'דרישת המים המירבית הדרושה במקור המים (חדר משאבות / רשת עירונית)'
    });
    this.sprinklerOffTimeRequirenments = new InspectionTimeCase({
      ...data.sprinklerOffTimeRequirenments,
      title: 'משך זמן כבוי נדרש בהתאם לדרישות התקן (min)'
    });
    this.requiredPoolingVolume = new InspectionWaterSupplyDataCase({
      ...data.requiredPoolingVolume,
      title: 'נפח איגום נדרש (m^3)'
    });
    this.hydraulicWaterRequirementMatchWaterSupplyDesign = new InspectionCase({
      ...data.hydraulicWaterRequirementMatchWaterSupplyDesign,
      title:
        'האם דרישת המים עפ"י החישובים ההידראולים מתאימה לנתוני מקור אספקת המים שתוכנן'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.deploymentAccordingSpec.isApplicable ||
        this.deploymentAccordingSpec.isPassed) &&
        (!this.pipingDesignType.isApplicable ||
          this.pipingDesignType.isPassed) &&
        (!this.preactionSystemType.isApplicable ||
          this.preactionSystemType.isPassed) &&
        (!this.systemTopPipingVolumeAccordingSpec.isApplicable ||
          this.systemTopPipingVolumeAccordingSpec.isPassed) &&
        (!this.maxWaterNeededAtMainStation.isApplicable ||
          this.maxWaterNeededAtMainStation.isPassed) &&
        (!this.maxWaterNeededAtSource.isApplicable ||
          this.maxWaterNeededAtSource.isPassed) &&
        (!this.sprinklerOffTimeRequirenments.isApplicable ||
          this.sprinklerOffTimeRequirenments.isPassed) &&
        (!this.requiredPoolingVolume.isApplicable ||
          this.requiredPoolingVolume.isPassed) &&
        (!this.hydraulicWaterRequirementMatchWaterSupplyDesign.isApplicable ||
          this.hydraulicWaterRequirementMatchWaterSupplyDesign.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.deploymentAccordingSpec.getNotes(),
      ...this.pipingDesignType.getNotes(),
      ...this.preactionSystemType.getNotes(),
      ...this.systemTopPipingVolumeAccordingSpec.getNotes(),
      ...this.maxWaterNeededAtMainStation.getNotes(),
      ...this.maxWaterNeededAtSource.getNotes(),
      ...this.sprinklerOffTimeRequirenments.getNotes(),
      ...this.requiredPoolingVolume.getNotes(),
      ...this.hydraulicWaterRequirementMatchWaterSupplyDesign.getNotes()
    ];
  }
}
